import angular from 'angular';

export class CompanyTopComponent {
  items = [
    {
      image: 'assets/images/IMG_1171_2.jpg',
      text: '観光バス事業への想い、今後のビジョンについて代表取締役、吉田周司からご紹介致します。',
      title1: 'MESSAGE',
      title2: 'トップメッセージ',
      state: 'statement'
    },
    {
      image: 'assets/images/IMG_1003-1.jpg',
      text: '会社概要についてご覧いただけます。',
      title1: 'ABOUT',
      title2: '会社概要',
      state: 'about'
    },
    {
      image: 'assets/images/IMG_1031.jpg',
      text: 'ここからお客様へサービスを。拠点地図をご案内致します。',
      title1: 'ACCESS',
      title2: 'アクセス',
      state: 'access'
    },
    {
      image: 'assets/images/world-trip2.jpg',
      text: '福井中央観光株式会社のグループ会社のご案内になります。',
      title1: 'OUR GROUP',
      title2: 'グループ会社',
      state: 'group'
    }
  ]
}

export default angular.module('directives.companyTop', [])
  .component('companyTop', {
    template: require('./companyTop.template.html'),
    controller: CompanyTopComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/company/companyTop.component.js